module.exports = __webpack_public_path__ + "img/blue2.f622e92a.svg";